import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import UserPlatformControl from '../formFields/UserPlatformControl';
import UserPlatformNumberDropdown from '../formFields/UserPlatformNumberDropdown';
import useGetAvailableNumbersDropdown from '../../queries/useGetAvailableNumbersDropdown';
import useCheckCurrentNumber from '../../queries/useCheckCurrentNumber';

const UserBaseSection = ({
    submitData,
    setSubmitData,
    errors,
    touched,
    platformUser,
    section,
}) => {
    const { darkMode } = useSelector((state) => state.settings);
    const { currentCompany } = useSelector((state) => {
        return { ...state.navigationLists };
    });
    const { requiredScope: accountScope } = useSelector((state) => state.login);

    const platformIndex = submitData.findIndex(
        (platform) => platform.platformID === platformUser?.platformID,
    );
    const platform = submitData[platformIndex];
    const [platformNumbers, setPlatformNumbers] = useState([]);
    const [initialNumber, setInitialNumber] = useState();
    const platformNumber = platformUser?.userProfiles[0]?.platformNumber;

    useEffect(() => {
        if (!platformUser?.userProfiles[0]?.platformNumber) {
            setInitialNumber({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { isFetching: isNumberChecking } = useCheckCurrentNumber(
        initialNumber || platformNumber,
        setInitialNumber,
        platformUser?.platformID,
        accountScope,
    );

    const { isFetching: isNumbersFetching } = useGetAvailableNumbersDropdown(
        currentCompany,
        platformNumber,
        platformUser?.platformID,
        setPlatformNumbers,
    );

    const isLoading = isNumberChecking || isNumbersFetching;

    const fields = [
        <UserPlatformControl
            key={`${section}-platform`}
            submitData={submitData}
            setPlatformUser={setSubmitData}
            errors={errors}
            touched={touched}
            darkMode={darkMode}
            section={section}
            platformID={platformUser?.platformID}
        />,
        platformUser?.managedBy === 0 && platformUser?.isLicensed && (
            <UserPlatformNumberDropdown
                key={`${section}-number`}
                setPlatformUser={setSubmitData}
                errors={errors}
                touched={touched}
                darkMode={darkMode}
                section={section}
                platformIndex={platformIndex}
                platform={platform}
                platformNumbers={platformNumbers}
                isLoading={isLoading}
            />
        ),
    ];
    return fields;
};

export default UserBaseSection;
